import { YearCoverage } from '@shared/api/types';
import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import { cn } from '@shared/lib/utils';

interface DataCoverageStatusProps {
  data: YearCoverage;
  className?: string;
}

type Status = 'complete' | 'partial' | 'no-data';

const getStatus: (year: YearCoverage) => {
  status: Status;
  description: string;
} = (year) => {
  if (year.hasData)
    return {
      status: 'complete',
      description: 'Data added for whole year',
    };

  const monthsWithData = year.months.filter((m) => m.hasData).length;

  if (monthsWithData === 0)
    return { status: 'no-data', description: 'No data added' };

  if (monthsWithData === 12)
    return { status: 'complete', description: 'Data added for all months' };

  const monthsMissingData = year.months.filter((m) => !m.hasData).length;
  return {
    status: 'partial',
    description: `Missing data for ${monthsMissingData} month${monthsMissingData > 1 ? 's' : ''}`,
  };
};

export function DataCoverageStatus({
  data,
  className,
}: DataCoverageStatusProps) {
  const { status, description } = getStatus(data);
  let icon = null;

  switch (status) {
    case 'complete':
      icon = <Icons.checkCircle className="size-4 text-secondary" />;
      break;
    case 'partial':
      icon = <Icons.circleMinus className="size-4 text-orange" />;
      break;
    case 'no-data':
      icon = <Icons.circle className="size-4 text-gray-200" />;
      break;
  }

  return (
    <span className={cn('flex items-center space-x-2', className)}>
      {icon}
      <Text variant="subtle" className="text-md">
        {description}
      </Text>
    </span>
  );
}
